import { setObject, getObject } from "../../utils/common";
import { TOP_RECOMMENDED_LOAD_COUNT } from '../../utils/constants'

export const error = {
  status: true,
  type: true,
  description: true,
  documentation: true,
  userErrorKey: true,
  timestamp: true
}
export const load = {
  loadId: true,
  loadPostingStatus: true,
  sourceSystem: true,
  isHazardous: true,
  isHighValue: true,
  isTemperatureControlled: true,
  totalDistance: true,
  distanceUOM: true,
  totalWeight: true,
  weightUOM: true,
  numberOfStops: true,
  transportMode: true,
  termsAndConditions: true,
  rate: {
    binRateIdentifier: true,
    totalCharge: true,
    lineHaulCharge: {
      charge: true,
      unitCharge: true,
      quantity: true,
      rateQualifier: true,
      chargeDescription: true,
    },
    fuelCharge: {
      charge: true,
      unitCharge: true,
      quantity: true,
      rateQualifier: true,
      chargeDescription: true,
    },
    accessorials: {
      accessorialCode: true,
      accessorialDescription: true,
      accessorialType: true,
      accessorialCharge: {
        charge: true,
        unitCharge: true,
        quantity: true,
        rateQualifier: true,
        chargeDescription: true,
      },
    },
  },
  loadStop: {
    locationName: true,
    addressLine1: true,
    addressLine2: true, 
    stopSequence: true,
    stopType: true,
    city: true,
    state: true,
    postalCode: true,
    country: true,
    stopId: true,
    appointmentFrom: true,
    appointmentTo: true,
    timeZone: true,
    deadHead: true,
    appointmentState: true,
    specialServices: {
      specialServiceDesc: true,
    },
  },
  buyAllowed: true,
  managedEquipment: true,
  similarLoads:true,
  capacityType: true
};
export class RecommendedModel {

  persistLoads(_loads: []) {
    return setObject("Carrier-rcmd-Loads", _loads);
  }

  getLoads() {
    return getObject("Carrier-rcmd-Loads");
  }
  getRequestPayload(isTopRecomm?:boolean) {
    let args = {}
    if(isTopRecomm) args = { __args: {input: { size:TOP_RECOMMENDED_LOAD_COUNT } } }
    const recommendedDataQuery = {
      query: {
        recommendedLoads: {
          ...args,
          loadPostings: {
            ...load,
            exclusiveLoad : true,
            rank: true
          },
          message: true,
          status: true,
          error:error,
          resultID: true
        },
      },
    };
    return recommendedDataQuery;
  }
}
